



























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import ReturObatItemTable from "./ReturObatItemTable.vue";
import ReturObatItemDialog from "./ReturObatItemDialog.vue";
import ReturObatFromResepDialog from "./ReturObatFromResepDialog.vue";
import ReturObatSvc from "@/services/ReturObatService";
import { storeReturObat } from "@/store/modules/ReturObatStore";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";

@Component({
  components: {
    CardModalTtd,
    ReturObatItemTable,
    ReturObatItemDialog,
    ReturObatFromResepDialog,
  }
})
export default class ReturObatForm extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData!: any;
  @Prop({ default: false }) readonly!: boolean;

  formValid = false;
  saving = false;
  showItemDialog = false;
  showResepDialog = false;
  editItemData: any = null;
  modalTtd = false;
  signRole = "";

  form: any = this.getEmptyForm();
  localItems: any[] = [];

  alasanOptions = [
    { value: "pasien_pulang", text: "Pasien Pulang" },
    { value: "terapi_berubah", text: "Perubahan Terapi" },
    { value: "efek_samping", text: "Efek Samping/Alergi" },
    { value: "pasien_meninggal", text: "Pasien Meninggal" },
    { value: "pasien_pindah", text: "Pasien Pindah Ruang/RS" },
    { value: "salah_dispensing", text: "Kesalahan Dispensing" },
    { value: "expired", text: "Obat/Alkes Expired" },
    { value: "rusak", text: "Obat/Alkes Rusak" },
    { value: "lainnya", text: "Lainnya" },
  ];

  mounted() {
    storeDokter.act_dokter_all();
    if (this.editData) {
      this.form = {
        alasan_retur: this.editData.alasan_retur,
        alasan_retur_detail: this.editData.alasan_retur_detail,
        depo_id: this.editData.depo_id,
        dpjp_id: this.editData.dpjp_id,
        diagnosa: this.editData.diagnosa,
        jenis_bayar: this.editData.jenis_bayar,
        catatan: this.editData.catatan,
      };
      this.localItems = JSON.parse(JSON.stringify(this.editData.items || []));
    } else {
      // Auto-fill dari data register pasien saat buat baru
      const reg = RegisterKunjungan.register;
      if (reg) {
        if (reg.dokter) {
          this.form.dpjp_id = reg.dokter.id;
        }
        if ((reg as any).asr) {
          this.form.jenis_bayar = (reg as any).asr.nama || "";
        }
      }
    }
  }

  getEmptyForm() {
    return {
      alasan_retur: "" as string,
      alasan_retur_detail: "" as string,
      depo_id: "" as string,
      dpjp_id: null as number | null,
      diagnosa: "" as string,
      jenis_bayar: "" as string,
      catatan: "" as string,
    };
  }

  get dokterList() {
    return storeDokter.listAll;
  }

  get hasNarkotika() {
    return this.localItems.some((i: any) => i.is_narkotika);
  }

  get canSend() {
    if (!this.editData) return false;
    if (this.localItems.length === 0) return false;
    if (!this.editData.perawat_signed_at) return false;
    if (this.hasNarkotika && !this.editData.saksi_signed_at) return false;
    return true;
  }

  openItemDialog() {
    this.editItemData = null;
    this.showItemDialog = true;
  }

  openEditItemDialog(item: any) {
    this.editItemData = JSON.parse(JSON.stringify(item));
    this.showItemDialog = true;
  }

  openResepDialog() {
    this.showResepDialog = true;
  }

  async onItemSaved(itemData: any) {
    if (!this.editData) {
      // Form belum di-save, simpan dulu
      appModule.NoticeDelay("Simpan retur terlebih dahulu sebelum menambah item");
      return;
    }

    try {
      if (itemData.id) {
        await ReturObatSvc.updateItem(this.editData.id, itemData.id, itemData);
        appModule.NoticeDelay("Item berhasil diperbarui");
      } else {
        await ReturObatSvc.addItem(this.editData.id, itemData);
        appModule.NoticeDelay("Item berhasil ditambahkan");
      }
      this.showItemDialog = false;
      await this.refreshDetail();
    } catch {
      // handled by service
    }
  }

  async onResepItemsSaved(items: any[]) {
    if (!this.editData) {
      appModule.NoticeDelay("Simpan retur terlebih dahulu sebelum menambah item dari resep");
      return;
    }

    try {
      await ReturObatSvc.addFromResep(this.editData.id, { items });
      appModule.NoticeDelay("Item dari resep berhasil ditambahkan");
      this.showResepDialog = false;
      await this.refreshDetail();
    } catch {
      // handled by service
    }
  }

  async onDeleteItem(item: any) {
    if (!this.editData) return;

    const q = confirm(`Hapus item "${item.nama_item}"?`);
    if (!q) return;

    try {
      await ReturObatSvc.deleteItem(this.editData.id, item.id);
      appModule.NoticeDelay("Item berhasil dihapus");
      await this.refreshDetail();
    } catch {
      // handled by service
    }
  }

  async simpan() {
    if (!(this.$refs.formRetur as any).validate()) return;
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        perawat_pengirim_user_id: userModule.user.id,
        ...this.form,
      };

      let resp;
      if (this.editData) {
        resp = await ReturObatSvc.update(this.editData.id, payload);
      } else {
        resp = await ReturObatSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Retur obat berhasil disimpan");
        this.$emit("saved");
      }
    } finally {
      this.saving = false;
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.editData) return;

    try {
      const signFn = this.signRole === "perawat"
        ? ReturObatSvc.signPerawat
        : ReturObatSvc.signSaksi;

      const resp = await signFn(this.editData.id, { password });

      if (resp.data.status == "1") {
        this.modalTtd = false;
        const label = this.signRole === "perawat" ? "Perawat" : "Saksi";
        appModule.NoticeDelay(`Berhasil Tanda Tangan ${label}`);
        appModule.addMsgTtd("");
        await this.refreshDetail();
      } else {
        appModule.addMsgTtd(resp.data.message);
        this.modalTtd = true;
      }
    } catch {
      // handled by service
    }
  }

  async kirimRetur() {
    if (!this.editData) return;
    const q = confirm("Kirim retur ke farmasi? Setelah dikirim, retur tidak dapat diubah.");
    if (!q) return;

    try {
      const resp = await ReturObatSvc.kirim(this.editData.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Retur berhasil dikirim ke farmasi");
        this.$emit("saved");
      }
    } catch {
      // handled by service
    }
  }

  cetakPdf() {
    if (this.editData) {
      ReturObatSvc.printPdf(this.editData.id);
    }
  }

  async refreshDetail() {
    if (!this.editData) return;
    try {
      const dt = await ReturObatSvc.find(this.editData.id);
      if (dt.data.status == "1") {
        Object.assign(this.editData, dt.data.data);
        this.localItems = JSON.parse(JSON.stringify(dt.data.data.items || []));
      }
    } catch {
      // handled by service
    }
  }
}
